<div class="dialog-padding">
  <h1 mat-dialog-title id="riderHasBalanceDialog-title" data-private>
    {{ data.organizationRider.firstName }} {{ data.organizationRider.lastName }} has an outstanding balance of:
    <span id="riderHasBalanceDialog-balance" class="balance">{{ data.organizationRider.balance | currency }}</span>
  </h1>
  <div mat-dialog-content>
    <p>Would you like to make a payment?</p>
  </div>
  <div mat-dialog-actions align="end">
    <button id="riderHasBalanceDialog-button-continueIntinerary" mat-button (click)="handleContinueToItinerary()">
      Continue To Itinerary
    </button>
    <button
      id="riderHasBalanceDialog-button-makePayment"
      *appRequiresPermissions="{ any: ['payment_processing'] }"
      mat-raised-button
      color="primary"
      (click)="handleMakePayment()"
    >
      Make Payment
    </button>
  </div>
</div>
